import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBxBroadcast = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "m19.707 4.293-1.414 1.414c2.733 2.733 2.733 7.353 0 10.086l1.414 1.414c3.5-3.5 3.5-9.414 0-12.914Zm-4.414 4.414c.566.566.879 1.292.879 2.043 0 .751-.313 1.477-.879 2.043l1.414 1.414c.944-.943 1.465-2.172 1.465-3.457 0-1.285-.521-2.514-1.465-3.457l-1.414 1.414Zm-9.086-3L4.793 4.293c-3.5 3.5-3.5 9.414 0 12.914l1.414-1.414c-2.733-2.733-2.733-7.353 0-10.086Z"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M7.293 7.293c-.944.943-1.465 2.172-1.465 3.457 0 1.285.52 2.514 1.465 3.457l1.414-1.414c-.566-.566-.88-1.292-.88-2.043 0-.751.314-1.477.88-2.043L7.293 7.293ZM14 10.5a2 2 0 1 0-3.105 1.666L10.002 22h3.996l-.893-9.835c.54-.358.895-.97.895-1.665Z"
	})]
});
export default SvgBxBroadcast;
